import { render } from "./DeviceDetails.vue?vue&type=template&id=74744612&scoped=true"
import script from "./DeviceDetails.vue?vue&type=script&lang=js"
export * from "./DeviceDetails.vue?vue&type=script&lang=js"

import "./DeviceDetails.vue?vue&type=style&index=0&id=74744612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74744612"]])

export default __exports__